import { createRootRoute, Outlet, useNavigate, useRouterState } from "@tanstack/react-router";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { Layout } from "../components/Layout/Layout";
import { useAuth } from "../lib/use-auth";

const CUSTOMER_HOME = "/stock-items";

export const rootRoute = createRootRoute({
	component: RootComponent,
});

function RootComponent() {
	const { user, isLoading, refetch } = useAuth();
	const navigate = useNavigate();
	const { location } = useRouterState();
	const isLoginPage = location.pathname === "/login";
	const { t } = useTranslation();

	useEffect(() => {
		if (isLoading) return;

		if (!user && !isLoginPage) {
			navigate({ to: "/login", replace: true });
		}

		if (user && isLoginPage) {
			navigate({ to: "/", replace: true });
		}

		if (user?.role === "customer" && !isLoginPage && location.pathname !== CUSTOMER_HOME) {
			navigate({
				to: CUSTOMER_HOME,
				search: {
					page: 1,
					size: 20,
					search: "",
					createdAtFrom: "",
					createdAtTo: "",
					status: "",
					category: "",
					brand: "",
				},
				replace: true,
			});
		}
	}, [user, isLoading, isLoginPage, location.pathname, navigate]);

	useEffect(() => {
		if (!isLoginPage) refetch();
	}, [location.pathname, isLoginPage, refetch]);

	if (isLoading) {
		return (
			<div
				style={{
					display: "flex",
					justifyContent: "center",
					alignItems: "center",
					height: "100dvh",
				}}
			>
				{t("loading")}
			</div>
		);
	}

	if (!user && !isLoginPage) {
		return null;
	}

	if (user?.role === "customer" && !isLoginPage && location.pathname !== CUSTOMER_HOME) {
		return null;
	}

	if (isLoginPage) {
		return <Outlet />;
	}

	return (
		<Layout>
			<Outlet />
		</Layout>
	);
}
